module.exports = __webpack_public_path__ + "img/feature_3.a7756c1e.jpg";